export default __webpack_public_path__ + "static/media/ado.cd081262.png";